import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, useCallback, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { FilterChip, } from '../FilterChip/FilterChip';
import SelectorDisplay from '../OptionSelector/SelectorDisplay';
import { TextLink } from '../TextLink';
const filterChipGroupStyles = css `
  display: flex;
  width: 100%;
`;
const FilterChipGroup = ({ disabled, filterChips, horizontalPadding, onClearAll, onClick: onGroupChipClicked, }) => {
    const handleChipClick = useCallback((chipValue, chipOnClick) => {
        if (typeof chipOnClick === 'function') {
            chipOnClick(chipValue);
        }
        else if (typeof onGroupChipClicked === 'function') {
            onGroupChipClicked(chipValue);
        }
    }, [
        onGroupChipClicked,
    ]);
    const handleClearAll = useCallback(() => {
        if (typeof onClearAll === 'function') {
            onClearAll();
        }
    }, [
        onClearAll,
    ]);
    const clearAllButtonStyles = useMemo(() => (css `
        padding-left: ${theme.spacing.x3};
        padding-right: ${theme.spacing.x3};
        padding-top: ${theme.spacing.x3};
        min-width: ${theme.spacing.x16};

        ${(horizontalPadding && (horizontalPadding > 0)) && css `
          padding-right: ${styleUtils.rem(horizontalPadding)};
        `}
      `), [
        horizontalPadding,
    ]);
    const isClearAllButtonVisible = useMemo(() => (typeof onClearAll === 'function'
        && filterChips.length > 0), [
        onClearAll,
        filterChips,
    ]);
    const chips = useMemo(() => (filterChips === null || filterChips === void 0 ? void 0 : filterChips.map((filterChip) => (_jsx(FilterChip, { disabled: disabled || Boolean(filterChip.disabled), label: filterChip.label, onClick: () => handleChipClick(filterChip.value, filterChip.onClick), swatchColor: filterChip.swatchColor, swatchImageUrl: filterChip.swatchImageUrl, value: filterChip.value }, filterChip.value)))), [
        filterChips,
        disabled,
        handleChipClick,
    ]);
    return (_jsxs("div", Object.assign({ css: filterChipGroupStyles }, { children: [_jsx(SelectorDisplay, Object.assign({ horizontalPadding: horizontalPadding, layout: 'scroll', stackLayout: "wrap" }, { children: chips })), isClearAllButtonVisible
                && (_jsx("div", Object.assign({ css: clearAllButtonStyles }, { children: _jsx(TextLink, { disabled: disabled, onClick: handleClearAll, size: "small", text: "Clear all", type: "secondary" }) })))] })));
};
const MemoizedFilterChipGroup = memo(FilterChipGroup);
export { MemoizedFilterChipGroup as FilterChipGroup };
// MC-1068 Temporary hack for Storybook.
export default MemoizedFilterChipGroup;
